// extracted by mini-css-extract-plugin
export default {"nextStepText":"EnterConfirmCodeWarning_nextStepText__hYeie","alert":"EnterConfirmCodeWarning_alert__C1Dbj","icon":"EnterConfirmCodeWarning_icon__ChiDc"};